export var HomeType = {
    UPDATE_NAV: "UPDATE_NAV",
    CHANGE_NAV_STATUS: "CHANGE_NAV_STATUS"
};
export default HomeType;
